import React from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { PageLoadingIndicator } from '@kioskgaming/page-loading';
import Button from '../../ui/Button';

interface TabSectionProps {
  isLoading: boolean;
  error: Error | null;
  onRetry: () => void;
  children: React.ReactNode;
}

/** Per-tab loading / error / content wrapper (section-level, not full-page). */
const TabSection: React.FC<TabSectionProps> = ({ isLoading, error, onRetry, children }) => {
  if (isLoading) {
    return (
      <div className="flex justify-center py-16">
        <PageLoadingIndicator
          variant="section"
          spinnerClassName="text-muted-foreground"
          labelClassName="text-muted-foreground"
        />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
        <AlertTriangle className="h-10 w-10 text-destructive" />
        <p className="font-medium text-destructive">Failed to load dashboard data</p>
        <p className="text-sm text-muted-foreground">{error.message}</p>
        <Button variant="outline" size="sm" onClick={onRetry}>
          <RefreshCw className="mr-2 h-4 w-4" />
          Try again
        </Button>
      </div>
    );
  }

  return <>{children}</>;
};

export default TabSection;
